<template>
  <b-container fluid>
    <backlink />
    <h1>Utilisateurs</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="actions" slot-scope="{ data }">
        <b-button
          v-b-tooltip.hover
          title="Modifier les autorisations"
          variant="outline-secondary"
          v-if="data.item.id"
          :to="{ name: 'UserAuthorization', params: { id: data.item.id } }"
        >
          <i class="far fa-key"></i>
        </b-button>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "UserList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
      source_items: null,
    };
  },
  computed: {
    options: function () {
      return {
        roles_options: this.available_roles,
        status_options: this.$store.getters["status/getByGroup"]("user").selectOptions(
          "status_slug",
          "name"
        ),
        // INC-001 : filtre par entrepôt de rattachement.
        // "none" = sans rattachement (accès à tous les entrepôts) ; "any" = rattaché à un entrepôt quelconque.
        warehouse_options: [
          { value: "none", text: "Tous les entrepôts (aucun rattachement)" },
          { value: "any", text: "Rattaché à un entrepôt (peu importe lequel)" },
          ...this.$store.getters["warehouse/getAll"].selectOptions("id", [
            "internal_code",
            " - ",
            "name",
          ]),
        ],
        // Filtre provenance MCS (comptes importés = user.source 'MCS').
        mcs_options: [
          { value: "only", text: "Uniquement les comptes MCS" },
          { value: "exclude", text: "Exclure les comptes MCS" },
        ],
      };
    },
    isSuperAdmin: function () {
      return this.$store.getters["auth/roles"][0] === "ROLE_SUPER_ADMIN";
    },
    available_roles: function () {
      let all_roles = this.$store.getters[config.storeNamespace + "/getRoles"];

      const user_roles = this.$store.getters["auth/roles"];
      if (
        user_roles[0] !== "ROLE_SUPER_ADMIN" &&
        user_roles[0] !== "ROLE_ADMIN" &&
        user_roles[0] !== "ROLE_DIRECTION"
      ) {
        return all_roles.filter(
          (role) => !["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_DIRECTION"].includes(role.value)
        );
      } else {
        return all_roles;
      }
    },
  },
  // created() {
  //   this.refreshSourceItems();
  // },
  mounted() {
    // INC-001 : nécessaire pour alimenter les options du filtre par entrepôt
    this.$store.dispatch("warehouse/getAll");
  },
  methods: {
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque 
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "user", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              // Pour un super-admin connecté, on n'impose pas de filtre rôle par défaut
              // afin que les super-admins (rôle absent de la liste sélectionnable) restent visibles.
              // Idem quand on demande "uniquement MCS" : le filtre porte sur la provenance,
              // le rôle ne doit pas le restreindre davantage.
              role_id:
                ctx.extended_filters_model.roles ||
                (self.isSuperAdmin || ctx.extended_filters_model.mcs === "only"
                  ? undefined
                  : self.available_roles.map((role) => role.value)),
              statusSlug: ctx.extended_filters_model.status,
              warehouse_id: ctx.extended_filters_model.warehouse,
              mcs: ctx.extended_filters_model.mcs,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.users || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/User/UserList.vue